import { render, staticRenderFns } from "./BuildingCheckRoomUsageStatus.vue?vue&type=template&id=141453d5&"
import script from "./BuildingCheckRoomUsageStatus.vue?vue&type=script&lang=js&"
export * from "./BuildingCheckRoomUsageStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports